import { gql } from "@apollo/client";

export const PUBLISH_PREVIEW = gql`
  mutation PublishPreview($instagramUsername: String!) {
    publishPreview(instagramUsername: $instagramUsername)
  }
`;

export interface PublishPreviewData {
  publishPreview: boolean;
}

export interface PublishPreviewVariables {
  instagramUsername: string;
}
